import React from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';

import { ImportSummaryTableView } from './ImportSummaryTable.view';

export const ImportSummaryTable = () => {
  const { importResponse } = React.useContext(ImportTestCasesStatusContext);

  return (
    <ImportSummaryTableView
      successCount={importResponse.success?.length ?? 0}
      errorsCount={importResponse.errors?.length ?? 0}
    />
  );
};
